import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admininscripciones-evento-crear',
  templateUrl: './admininscripciones-evento-crear.component.html',
  styleUrls: ['./admininscripciones-evento-crear.component.scss']
})
export class AdmininscripcionesEventoCrearComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/admininscripciones-evento-crear/admininscripciones-evento-crear.component.ts